const CheckboxMultiSelect = {
  init() {
    document.querySelectorAll("select.checkbox-multi-select").forEach(selectEl => {
      if (selectEl.dataset.checkboxMultiSelectInitialized === "true") return;

      this.initMultiSelect(selectEl);
      selectEl.dataset.checkboxMultiSelectInitialized = "true";
    });
  },

  initMultiSelect(selectEl) {
    const options = Array.from(selectEl.options)
      .filter(option => option.value.trim() !== "")
      .map(option => ({
        value: option.value,
        label: option.text.trim(),
        element: option
      }));

    const placeholder = this.getLocalizedText("localized-select-prompt", "Select option...");
    const selectAllLabel = this.getLocalizedText("localized-select-all", "Select all");
    const unselectAllLabel = this.getLocalizedText("localized-unselect-all", "Unselect all");

    const selectedValues = new Set(
      options.filter(option => option.element.selected).map(option => option.value)
    );

    selectEl.style.display = "none";
    selectEl.removeAttribute("required");

    const wrapper = this.createWrapper(selectEl.id, placeholder);
    selectEl.insertAdjacentElement("beforebegin", wrapper);

    const tagsContainer = wrapper.querySelector(".multi-select-tags");
    const input = wrapper.querySelector(".multi-select-input");
    const dropdown = wrapper.querySelector(".multi-select-dropdown");

    const syncSelect = () => {
      options.forEach(option => {
        option.element.selected = selectedValues.has(option.value);
      });

      selectEl.dispatchEvent(new Event("change", {bubbles: true}));
      selectEl.dispatchEvent(new Event("input", {bubbles: true}));
      selectEl.dispatchEvent(new CustomEvent("multi-select:change", {bubbles: true}));
    };

    const renderTags = () => {
      tagsContainer.innerHTML = "";

      options
        .filter(option => selectedValues.has(option.value))
        .forEach(option => {
          const tag = document.createElement("div");
          tag.className = "multi-select-tag";
          tag.dataset.value = option.value;

          const text = document.createElement("span");
          text.textContent = option.label;

          const remove = document.createElement("span");
          remove.className = "multi-select-tag-remove-icon";
          remove.textContent = "×";

          remove.addEventListener("click", event => {
            event.stopPropagation();

            selectedValues.delete(option.value);
            const dropdownOpen = dropdown.style.display === "block";
            syncSelect();
            renderTags();
            if (dropdownOpen) renderDropdown(input.value);
          });

          tag.appendChild(text);
          tag.appendChild(remove);
          tagsContainer.appendChild(tag);
        });
    };

    const setAll = selected => {
      if (selected) {
        options.forEach(option => selectedValues.add(option.value));
      } else {
        selectedValues.clear();
      }

      syncSelect();
      renderTags();
      renderDropdown(input.value);
    };

    const setOption = (value, selected) => {
      if (selected) {
        selectedValues.add(value);
      } else {
        selectedValues.delete(value);
      }

      syncSelect();
      renderTags();
      renderDropdown(input.value);
    };

    const renderDropdown = (searchValue = "") => {
      dropdown.innerHTML = "";

      const normalizedSearch = searchValue.toLowerCase().trim();
      const filteredOptions = options.filter(option =>
        option.label.toLowerCase().includes(normalizedSearch)
      );

      const allSelected = options.length > 0 && selectedValues.size === options.length;
      const someSelected = selectedValues.size > 0 && !allSelected;

      const selectAllLi = document.createElement("li");
      selectAllLi.className = "checkbox-multi-select-select-all";

      const selectAllLabelEl = document.createElement("label");
      selectAllLabelEl.className = "checkbox-multi-select-checkbox-label";
      selectAllLabelEl.style.display = "flex";
      selectAllLabelEl.style.alignItems = "center";
      selectAllLabelEl.style.gap = "0.4rem";

      const selectAllCheckbox = document.createElement("input");
      selectAllCheckbox.type = "checkbox";
      selectAllCheckbox.className = "checkbox-multi-select-select-all-checkbox";
      selectAllCheckbox.checked = allSelected;
      selectAllCheckbox.indeterminate = someSelected;

      const selectAllText = document.createElement("span");
      selectAllText.textContent = allSelected ? unselectAllLabel : selectAllLabel;

      selectAllCheckbox.addEventListener("click", event => {
        event.stopPropagation();
      });

      selectAllCheckbox.addEventListener("change", () => {
        setAll(selectAllCheckbox.checked);
      });

      selectAllLi.addEventListener("click", event => {
        event.stopPropagation();

        if (event.target.tagName.toLowerCase() !== "input") {
          setAll(!allSelected);
        }
      });

      selectAllLabelEl.appendChild(selectAllCheckbox);
      selectAllLabelEl.appendChild(selectAllText);
      selectAllLi.appendChild(selectAllLabelEl);
      dropdown.appendChild(selectAllLi);


      filteredOptions.forEach(option => {
        const li = document.createElement("li");
        li.className = "checkbox-multi-select-item";

        const label = document.createElement("label");
        label.className = "checkbox-multi-select-checkbox-label";
        label.style.display = "flex";
        label.style.alignItems = "center";
        label.style.gap = "0.4rem";

        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "checkbox-multi-select-option-checkbox";
        checkbox.value = option.value;
        checkbox.checked = selectedValues.has(option.value);

        const text = document.createElement("span");
        text.textContent = option.label;

        checkbox.addEventListener("click", event => {
          event.stopPropagation();
        });

        checkbox.addEventListener("change", () => {
          setOption(option.value, checkbox.checked);
        });

        li.addEventListener("click", event => {
          event.stopPropagation();

          if (event.target.tagName.toLowerCase() !== "input") {
            setOption(option.value, !selectedValues.has(option.value));
          }
        });

        label.appendChild(checkbox);
        label.appendChild(text);
        li.appendChild(label);
        dropdown.appendChild(li);
      });

      dropdown.style.display = "block";
    };

    const hideDropdown = () => {
      dropdown.style.display = "none";
    };

    const showDropdown = () => {
      renderDropdown(input.value);
    };

    wrapper.addEventListener("click", event => {
      if (event.target.classList.contains("multi-select-tag-remove-icon")) return;

      input.focus();
      showDropdown();
    });

    input.addEventListener("focus", () => {
      showDropdown();
    });

    input.addEventListener("input", () => {
      showDropdown();
    });

    input.addEventListener("keydown", event => {
      if (event.key === "Escape") {
        hideDropdown();
      }
    });

    dropdown.addEventListener("click", event => {
      event.stopPropagation();
    });

    document.addEventListener("click", event => {
      if (!wrapper.contains(event.target)) hideDropdown();
    });

    renderTags();
    syncSelect();
  },

  createWrapper(selectId, placeholder) {
    const wrapper = document.createElement("div");
    wrapper.className = "multi-select-container checkbox-multi-select-container relative select-id-" + selectId;

    const tagsContainer = document.createElement("div");
    tagsContainer.className = "multi-select-tags flex flex-wrap gap-1";

    const input = document.createElement("input");
    input.type = "text";
    input.className = "multi-select-input";
    input.autocomplete = "off";
    input.placeholder = placeholder;

    const dropdown = document.createElement("ul");
    dropdown.className = "multi-select-dropdown absolute bg-white border border-gray-300 dark:border-gray-700 rounded-md mt-1 max-h-48 overflow-y-auto z-10";

    wrapper.appendChild(tagsContainer);
    wrapper.appendChild(input);
    wrapper.appendChild(dropdown);

    return wrapper;
  },

  getLocalizedText(metaName, fallback) {
    const meta = document.querySelector("meta[name=\"" + metaName + "\"]");
    return meta ? meta.getAttribute("content") : fallback;
  }
};

document.addEventListener("DOMContentLoaded", () => CheckboxMultiSelect.init());
